const config = {
  apiUrl: typeof window.sunbitApiHost === 'undefined' ? null : window.sunbitApiHost,
};

export default config;



// WEBPACK FOOTER //
// ./src/config/kubernetes.js